<template>
  <div class="container">
    <div class="header" v-if="header">
        <h3>{{header}}</h3>
         <div>
            <IconBase
                :height="24"
                :width="24"
                :view-box="`0 0 24 24`"
                :fill="'#E7E6FA'"
            >
                <IconCross v-if="isCrossEnable" />
            </IconBase>
        </div>
    </div>
    <p>
        {{message}}
        <!-- Beyond 40 participants, the room will switch to expanded mode where only 3 video streams will be visible at all times to optimize performance. -->
    </p>
  </div>
</template>

<script>
import IconBase from '../IconBase'
import IconCross from '../icons/IconCross'
export default {
    components: {
        IconBase,
        IconCross
    },
    props:['message','isCrossEnable','header']
}
</script>

<style scoped>
.container {
    width: 258px;
    max-height: 136px;
    background: #5D5D7A;
    border-radius: 4px;
    padding: 8px 12px 12px 12px;
}

.header {
    display: flex;
    justify-content: space-between;
}

h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #E7E6FA;
    margin: 0;
}

p {
    margin-top: 20px;
    padding: 0;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #E7E6FA;
    word-break: normal;
}
</style>